<!-- Card -->
<section class="card mt-4">
  <!-- Header -->
  <div class="card-header">
    <h3 class="card-title">
      {{ 'saleModule.sales' | translate }}
    </h3>
  </div>
  <!-- End Header -->

  <!-- Body -->
  <div>
    <sale-table
      [showTotal]="true"
      [tableData$]="sales$"
      [isFromBooking]="false"
      (onClickRow)="onClickRow($event)"
      [saleTableOptions]="{ hideMember: false, hideCheckbox: true }"
    ></sale-table>
  </div>
  <!-- End Body -->
</section>
<!-- End Card -->
